import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { msalConfig } from "./auth/authConfig";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { Provider } from "react-redux";
import store, { persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";

const msalInstance = new PublicClientApplication(msalConfig);

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = import.meta.env.DEV ? '/dev-sw.js?dev-sw' : '/sw.js';
    const swOptions: RegistrationOptions = { scope: '/', type: import.meta.env.DEV ? 'module' : 'classic' };

    navigator.serviceWorker.register(swUrl, swOptions)
      .then((registration) => {
        console.log('PWA Service Worker registered:', registration);
      })
      .catch((registrationError) => {
        console.warn('PWA Service Worker registration skipped/failed:', registrationError);
      });
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
      <App />
        </PersistGate>
      </Provider>
    </MsalProvider>
  </React.StrictMode>
);
